import React from "react";
import Badge from "@Components/Badge";
import PiggyBank from "@Components/Icons/PiggyBank";
import LoadingFallback from "@Components/Pages/Fallbacks/Loading";
import { format } from "@Shared/Helpers/Money";
import styles from "./index.module.scss";
export default function Savings(props) {
    const { tender, dateRange = "" } = props;
    if (tender === undefined) {
        return React.createElement(LoadingFallback, null);
    }
    const newTariff = tender.stats.totalLines - tender.stats.unusedLines;
    const badgeWidth = Math.max(newTariff.toString().length, tender.stats.unusedLines.toString().length);
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.header },
            React.createElement("div", { className: styles.headerContent },
                React.createElement("div", { className: styles.iconContainer },
                    React.createElement(PiggyBank, { size: "16px" })),
                React.createElement("div", { className: styles.headerText },
                    React.createElement("p", { className: styles.headerTitle },
                        "Predicted",
                        " ",
                        React.createElement("span", { className: styles.primaryColor }, "Total Saving")))),
            React.createElement("div", { className: styles.subtitle },
                React.createElement("p", null, "While not mandatory, this will give the ideal results"))),
        React.createElement("div", { className: styles.totalSavingCard },
            React.createElement("p", { className: styles.cardTitle }, "Total saving"),
            React.createElement("p", { className: styles.cardText }, "At contract renewal you will save at least"),
            React.createElement("div", { className: styles.totalSavingAmount },
                React.createElement("div", { className: styles.amountContent },
                    React.createElement("p", { className: styles.amountText }, Number.isNaN(tender.totalSavings) ? (React.createElement(React.Fragment, null, "\u00A30")) : (format(tender.totalSavings, 0)))))),
        React.createElement("div", { className: styles.componentsTitle },
            React.createElement("p", null, "Saving consists of two components...")),
        React.createElement("div", { className: styles.componentsCard },
            React.createElement("div", { className: styles.componentSection },
                React.createElement("p", { className: styles.cardTitle }, "New tariff"),
                React.createElement("div", { className: styles.badgeTextRow },
                    React.createElement(Badge, { width: badgeWidth }, newTariff),
                    React.createElement("p", { className: styles.badgeText },
                        "lines actively used on your account",
                        " ",
                        dateRange && `${dateRange} `,
                        "at contract renewal saves")),
                React.createElement("div", { className: styles.amountBox },
                    React.createElement("div", { className: styles.amountContent },
                        React.createElement("p", { className: styles.amountTextBlue }, Number.isNaN(tender.benchmarkSavings) ? (React.createElement(React.Fragment, null, "\u00A30")) : (format(tender.benchmarkSavings, 0)))))),
            React.createElement("div", { className: styles.componentSection },
                React.createElement("p", { className: styles.cardTitle }, "Unused lines"),
                React.createElement("div", { className: styles.badgeTextRow },
                    React.createElement(Badge, { width: badgeWidth }, tender.stats.unusedLines),
                    React.createElement("p", { className: styles.badgeText }, "lines if removed will save")),
                React.createElement("div", { className: styles.amountBox },
                    React.createElement("div", { className: styles.amountContent },
                        React.createElement("p", { className: styles.amountTextBlue }, Number.isNaN(tender.unusedLinesSavings) ? (React.createElement(React.Fragment, null, "\u00A30")) : (format(tender.unusedLinesSavings, 0))))))),
        props.slot && React.createElement("div", { className: styles.slot }, props.slot)));
}
